import * as React from "react";
import { useHistory, Prompt } from "react-router-dom";
import { setDisableRedirect } from "State/App/AppReducer";
import { useSelector, useDispatch } from "react-redux";
import { RootStateType } from "State/Store";
import { Location, History } from "history";
import { PrimaryModal } from "Components/Shared/PrimaryModal";
import { useResource, Resources } from "Translations/Resources";

type Props = {};

export const ConfirmRedirect: React.FunctionComponent<Props> = _ => {
  const { t } = useResource();
  const history = useHistory();
  const dispatch = useDispatch();
  const { disableRedirect } = useSelector((e: RootStateType) => e.app);

  const [nextLocation, setNextLocation] = React.useState<string | null>(null);
  const [confirmedRedirect, setConfirmedRedirect] = React.useState<boolean>(
    true,
  );

  React.useEffect(() => {
    setConfirmedRedirect(!disableRedirect);
    if (disableRedirect) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = null;
    }
  }, [disableRedirect]);

  React.useEffect(() => {
    if (nextLocation && confirmedRedirect) {
      history.push(nextLocation);
    }
  }, [nextLocation, confirmedRedirect, history]);

  const handleBlockedNavigation = (
    location: Location<History.LocationState>,
  ) => {
    if (disableRedirect && !confirmedRedirect) {
      setNextLocation(location.pathname);
      return false;
    }

    setNextLocation(null);
    dispatch(setDisableRedirect(false));
    return true;
  };

  return (
    <>
      <Prompt when={disableRedirect} message={handleBlockedNavigation} />
      <PrimaryModal
        open={!!nextLocation}
        closeBtnText={t(Resources.Common.ConfirmRedirect.Close)}
        successBtnText={t(Resources.Common.ConfirmRedirect.Success)}
        title={t(Resources.Common.ConfirmRedirect.Title)}
        onClose={() => setNextLocation(null)}
        onSuccess={() => {
          setConfirmedRedirect(true);
        }}
      />
    </>
  );
};
